<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="edit-channel"
  >
    <Form
      ref="form"
      :form-data="formData"
      :push-list="pushList"
      @submit="submitHandle"
    ></Form>
  </sliderBarDialogShell>
</template>

<script>
import { editMt4Config } from "@/api/sys/mt4Chanel";
import Form from '@/components/sys/mt4Channel/Form'

export default {
  name: 'edit',
  components:{
      Form,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    pushList:{},
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      title: '修改MT4推送配置'
    }
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },
    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
        let params = {
          id: formData.id,
          ruleId: formData.ruleId,
          name: formData.userName,
          mt4Id: formData.login,
          remark: formData.remark,
          status: formData.status,
          type:formData.type,
        }
      editMt4Config(params).then((res) => {
            this.$refs.form.$refs.form.clearValidate();
            this.$refs.form.$refs.form.resetFields();
            this.$emit('edit-success');
            this.$refs.form.reset();
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
<style>
@media screen and (min-width: 768px) {
  .edit-channel.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
